<div class="d-flex justify-content-between align-items-center">
  @if (isCreateUpadateRemoveAccess) {
  <div>
    <button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#createPriceListModal">
      Create
    </button>
  </div>
  }
  @if (isDealer || isSuperAdmin) {
  <div
    class="btn-group btn-group-sm m-0 p-0 d-inline-flex align-items-center rounded-pill border shadow-sm transition-base bg-body-tertiary"
    role="group">

    <input type="radio" class="btn-check" name="btnradio" id="btnradioall" [value]="CompanyCodeEnum.ALL"
      (change)="onRadioChange($event)" checked>
    <!-- Added m-0 (removes bottom space) and d-flex align-items-center (centers text vertically) -->
    <label
      class="btn btn-outline-primary rounded-pill border-0 px-3 m-0 d-flex align-items-center fw-bold text-uppercase"
      for="btnradioall">
      {{ CompanyCodeEnum.ALL }}
    </label>

    <input type="radio" class="btn-check" name="btnradio" id="btnradiopnc" [value]="CompanyCodeEnum.PNC"
      (change)="onRadioChange($event)">
    <label
      class="btn btn-outline-primary rounded-pill border-0 px-3 m-0 d-flex align-items-center fw-bold text-uppercase"
      for="btnradiopnc"> P&C </label>

    <input type="radio" class="btn-check" name="btnradio" id="btnradiobw" [value]="CompanyCodeEnum.BW"
      (change)="onRadioChange($event)">
    <label
      class="btn btn-outline-primary rounded-pill border-0 px-3 m-0 d-flex align-items-center fw-bold text-uppercase"
      for="btnradiobw">
      {{ CompanyCodeEnum.BW }}
    </label>

  </div>
  }
</div>


<div class="table-responsive mt-2">
  <table class="table">
    <thead>
      <tr>
        <th>SrNo</th>
        @if (!isDealer) {
        <th>Name</th>
        }
        <th>Description</th>
        <th>Effective Date</th>
        <th>File Name</th>
        @if (isCreateUpadateRemoveAccess) {
        <th></th>
        }
      </tr>
    </thead>
    <tbody>
      @for ( data of priceList | paginate: {
      itemsPerPage: pageSize,
      currentPage: page + 1,
      totalItems: allTotal,};track data ) {
      <tr>
        <td>{{ data.srNo }}</td>
        @if (!isDealer) {
        <td>{{ data.name }}</td>
        }
        <td>{{ data.description }}</td>
        <td>{{ data.effectiveDate | dateFormat }}</td>
        <td>
          <button type="button" class="btn btn-link" (click)="openPDF(data)">
            {{ data.fileName }}
          </button>
        </td>
        @if (isCreateUpadateRemoveAccess) {
        <td>
          <div style="text-align: right">
            <button type="button" class="btn btn-primary" (click)="openUpdateModel(data)">
              Update
            </button>
            <button type="button" class="btn btn-danger ml-3" (click)="removePriceList(data.name)">
              @if (isUploading) {
              <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
              }
              @if (!isUploading) {
              <span>Remove</span>
              }
            </button>
          </div>
        </td>
        }
      </tr>
      }
    </tbody>
  </table>
</div>

<div style="text-align: center">
  <pagination-controls [maxSize]="20" previousLabel="Prev" nextLabel="Next" [responsive]="true"
    (pageChange)="handlePageChange($event)"></pagination-controls>
</div>
@if (loading) {
<div class="loading d-flex justify-content-center">
  <div class="spinner-border text-primary" role="status"></div>
</div>
}

<!-- Create Price List Model -->
<div class="modal" id="createPriceListModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Create Price List</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="createPriceListForm">
          <div class="mb-3">
            <label class="form-label">Name</label>
            <input type="text" class="form-control" formControlName="name" />
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <input type="text" class="form-control" formControlName="description" />
          </div>
          <div class="mb-3">
            <label class="form-label">Effective Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                ngbDatepicker #d="ngbDatepicker" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">File (pdf only)</label>
            <input type="file" class="form-control" formControlName="file" accept=".pdf"
              (change)="onFileSelected($event)" />
          </div>
          @if (isSuperAdmin) {
          <div class="mb-3">
            <label class="form-label" for="companyCode">Company Code</label>
            <select id="companyCode" class="form-select" formControlName="companyCode">
              <option [value]="CompanyCodeEnum.PNC">P&C</option>
              <option [value]="CompanyCodeEnum.BW">BW</option>
            </select>
          </div>
          }
        </form>
        @if (isError) {
        <div>
          <div class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
        </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="createPriceList()"
          [disabled]="!createPriceListForm.valid">
          @if (isUploading) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
          <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Update Price List Model -->
<div class="modal" tabindex="-1" [ngStyle]="{ display: displayStyle }" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Update Rebate</h5>
      </div>
      <div class="modal-body">
        <form [formGroup]="updatePriceListForm">
          <div class="mb-3">
            <label class="form-label">Effective Date (DD/MM/YYYY)</label>
            <div class="input-group">
              <input type="text" class="form-control" formControlName="effectiveDate" placeholder="DD/MM/YYYY"
                ngbDatepicker #dupdate="ngbDatepicker" />
              <div class="input-group-append">
                <button class="btn btn-outline-secondary" (click)="dupdate.toggle()" type="button">
                  <i class="bi bi-calendar3"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">Description</label>
            <input type="text" class="form-control" formControlName="description" />
          </div>
        </form>
        @if (isError) {
        <div>
          <div class="alert alert-danger" role="alert">
            {{ errorMessage }}
          </div>
        </div>
        }
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModel()">
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="updatePriceList()"
          [disabled]="!updatePriceListForm.valid">
          @if (isUploading) {
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          }
          @if (!isUploading) {
          <span>Submit</span>
          }
        </button>
      </div>
    </div>
  </div>
</div>
